// extracted by mini-css-extract-plugin
export default {"button":"LoginPage_button__Eu1tI","content":"LoginPage_content__forB6","loading":"LoginPage_loading__bYoRK","container":"LoginPage_container__jN6-7"};